import { render, staticRenderFns } from "./TeacherSuperAdminPreSelect.vue?vue&type=template&id=22f23e52"
import script from "./TeacherSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./TeacherSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports